module.exports = __webpack_public_path__ + "static/media/hr.7998a831.jpg";